import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../core/store";

export const PrivateRoute = () => {
    const { access_token } = useAppSelector((state) => state.auth);

    return access_token ? <Outlet /> : <Navigate to="/" />;
};
